import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Shield, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { DeleteAccountModal } from "../components/DeleteAccountModal";

const AccountDeletePage = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  useEffect(() => {
    if (isLoggedIn) setOpen(true);
  }, [isLoggedIn]);

  return (
    <div className="min-h-screen bg-[#0a0a12] flex flex-col">
      <header className="border-b border-white/10 bg-[#0a0a12]/95 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo.png" alt="Fieldz AI" className="h-8" />
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-white/70 hover:text-white">
              <ArrowLeft className="w-4 h-4 mr-2" /> Back
            </Button>
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4" data-testid="account-delete-page">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 rounded-2xl bg-red-500/10 flex items-center justify-center mx-auto mb-6">
            <Shield className="w-8 h-8 text-red-400" />
          </div>
          <h1 className="text-2xl font-bold text-white font-['Manrope'] mb-3">Account Deletion</h1>
          <p className="text-white/60 text-sm mb-8 leading-relaxed">
            To delete your Fieldz AI account and all associated data, please log in first. 
            Your data will be permanently removed within 30 days as described in our{" "}
            <Link to="/privacy" className="text-[#FFCC00] hover:underline">Privacy Policy</Link>.
          </p>
          {isLoggedIn ? (
            <Button
              onClick={() => setOpen(true)}
              variant="destructive"
              className="px-8 py-5"
              data-testid="open-delete-modal-btn"
            >
              Delete My Account
            </Button>
          ) : (
            <Button
              onClick={() => navigate("/login?redirect=/account/delete")}
              className="btn-primary px-8 py-5"
              data-testid="login-to-delete-btn"
            >
              Log In to Continue
            </Button>
          )}
        </div>
      </main>

      <DeleteAccountModal open={open} onOpenChange={setOpen} />
    </div>
  );
};

export default AccountDeletePage;
